@import '../../../globals/main.scss';

$check-timing: 180ms;
$bg-timing: 220ms;
$easing: cubic-bezier(0.79, 0.14, 0.15, 0.86);

:host {
  display: inline-block;
  user-select: none;

  input {
    opacity: 0;
    position: absolute;
  }

  input[type='checkbox'] {
    & + label.pn-checkbox {
      width: 1.5em;
      min-width: 1.5em;
      height: 1.5em;
      min-height: 1.5em;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      border: 0.1rem solid $gray400;
      cursor: pointer;
      border-radius: 0.4rem;
      cursor: pointer;
      transition-duration: $bg-timing;
      transition-timing-function: $easing;
      transition-property: border, background, box-shadow;

      svg {
        width: 80%;
        fill: none;

        polyline {
          stroke: #fff;
          transform-origin: 0 0;
          stroke-linecap: round;
          stroke-dasharray: 23;
          stroke-dashoffset: 23;
          transition-delay: none;
          transition: stroke-dashoffset $check-timing $easing;
        }
      }
    }

    &:hover + label.pn-checkbox {
      border: 0.1rem solid $blue700;
      background: $blue50;
    }

    &:checked + label.pn-checkbox,
    &:indeterminate + label.pn-checkbox {
      background: $blue700;
      border: 0.1rem solid $blue700;

      svg polyline {
        transition-delay: $bg-timing;
      }
    }

    &:checked + label.pn-checkbox {
      svg polyline.checkmark-path {
        stroke-dashoffset: 0;
      }
    }

    &:indeterminate + label.pn-checkbox {
      svg polyline.indeterminate-path {
        stroke-dashoffset: 0;
      }
    }

    &:focus + label.pn-checkbox,
    &:active + label.pn-checkbox {
      box-shadow:
        0 0 0 0.1rem white,
        0 0 0 0.3rem $blue700;
    }

    &:disabled + label.pn-checkbox {
      background-color: $gray200;
      border: 0.1rem solid $gray400;
      cursor: not-allowed;

      svg polyline {
        stroke: $gray400;
      }
    }

    &:disabled:checked + label.pn-checkbox {
      border: 0.1rem solid transparent;
    }

    &:disabled:active + label.pn-checkbox {
      box-shadow: none;
    }
  }
}
